/* global jQuery*/

export default class HandleCheckout {
  constructor () {
    this.checkoutFlow = jQuery('.mtt-checkout-flow')
    if (this.checkoutFlow.length === 0) {
      return
    }

    this.setupCheckoutFlow()
    this.setupPlaceholderText()
  }

  setupCheckoutFlow () {
    this.setupPrice()
    this.setupAmount()
  }

  setupPlaceholderText () {
    this.checkoutFlow.on('input', 'input', this.showOrHidePlaceholder.bind(this))
    this.checkoutFlow.on('input', 'textarea', this.showOrHidePlaceholder.bind(this))
  }

  showOrHidePlaceholder (e) {
    e.preventDefault()

    let currentTarget = jQuery(e.currentTarget)
    let spanPlaceholder = currentTarget.parent().find('span.input-placeholder-text')

    if (currentTarget.val() === '') {
      spanPlaceholder.addClass('hidden')
    } else {
      spanPlaceholder.removeClass('hidden')
    }
  }

  setupPrice () {
    let perPersonPriceElement = jQuery('.mtt-rooms-loop__info-price-per-person .second')
    let depositPriceElement = jQuery('.mtt-rooms-loop__info-depo .second')

    this.perPersonPrice = perPersonPriceElement.data('room-price')
    this.perPersonPriceOne = perPersonPriceElement.data('room-price-one')
    this.amount = perPersonPriceElement.data('amount')
  }

  setupAmount () {
    this.checkoutFlowAmount = this.checkoutFlow.find('select[name="amount"]')
    if (!this.checkoutFlowAmount) {
      return
    }

    this.checkoutFlowAmount.on('change', function (e) {
      let select = jQuery(e.currentTarget)
      this.amount = parseInt(select.val())

      this.updatePrices()
    }.bind(this))
  }

  updatePrices () {
    let price = this.amount === 1 ? this.perPersonPriceOne : this.perPersonPrice
    let totalPrice = price * this.amount

    let perPersonPriceElement = jQuery('.mtt-rooms-loop__info-price-per-person .second')
    perPersonPriceElement.html(price.toLocaleString('da-DK', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' DKK')

    let totalPriceElement = jQuery('.mtt-rooms-loop__info-price .second')
    totalPriceElement.html(totalPrice.toLocaleString('da-DK', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' DKK')
  }

}
